import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { get_session9cytjmfbg8nd as get_session } from '../sdk/UserSession.mjs';
import { await1kke5zj2piplv as await_0 } from '../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { LineItem2rt64afaiyloc as LineItem } from '../../../../crowpay-shared/com/crowpay/databaseModels.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { serializerOrContextual1whp5jyfp32aq as serializerOrContextual } from '../../../../lightning-server-shared/com/lightningkite/serialization/SerializationHelpers.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { DataClassPathSelf9694s3fei65z as DataClassPathSelf } from '../../../../lightning-server-shared/com/lightningkite/serialization/DataClassPath.mjs';
import {
  get_scopeSet9qq32a9d0llm as get_scopeSet,
  get_state1s5baftgdwrse as get_state,
  get__id219tqyp0nxml1 as get__id,
} from '../../../../crowpay-shared/com/crowpay/LineItemFields.mjs';
import {
  eq1298m2cje971u as eq,
  neqqjkp0prqcfuy as neq,
} from '../../../../lightning-server-shared/com/lightningkite/lightningdb/ConditionBuilder.mjs';
import { andvtrcuje7baox as and } from '../../../../lightning-server-shared/com/lightningkite/lightningdb/Condition.mjs';
import { Query38t34cs21ulcf as Query } from '../../../../lightning-server-shared/com/lightningkite/lightningdb/Query.mjs';
import {
  coroutineScope284yy3flyb2v2 as coroutineScope,
  CoroutineScopefcb5f5dwqcas as CoroutineScope,
} from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  plus20p0vtfmu0596 as plus,
  chunked1umgsyuj0x9u1 as chunked,
  dropLast1vpiyky649o34 as dropLast,
} from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { asyncz02dsa2nb2zt as async } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import { awaitAll3u8r91uegk3sa as awaitAll } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/Await.mjs';
import { initMetadataForLambda3af3he42mmnh as initMetadataForLambda } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { shuffled357jrbcm2hlkc as shuffled } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function repeatForScopeSets(item, action, $completion) {
  return repeatForScopeSets_0(item.hf9_1, action, $completion);
}
function *_generator_repeatForScopeSets__9o68jz(item, action, $completion) {
  if (item.k6k_1 == null) {
    var tmp = action(item, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    return Unit_instance;
  }
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp_0 = await_0(this_0, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp_1 = tmp_0.mfv_1;
  // Inline function 'com.lightningkite.lightningdb.Query' call
  var limit = 2147483647;
  // Inline function 'kotlin.collections.listOf' call
  var orderBy = emptyList();
  // Inline function 'com.lightningkite.lightningdb.path' call
  // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
  var tmp_2 = serializerOrContextual(createKType(getKClass(LineItem()), arrayOf([]), false));
  var tmp$ret$2 = isInterface(tmp_2, KSerializer()) ? tmp_2 : THROW_CCE();
  var it = new (DataClassPathSelf())(tmp$ret$2);
  var tmp$ret$4 = and(and(eq(get_scopeSet(it), item.k6k_1), eq(get_state(it), item.r6k_1)), neq(get__id(it), item.g6k_1));
  var tmp$ret$5 = new (Query())(tmp$ret$4, orderBy, 0, limit);
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_1 = tmp_1.feo(tmp$ret$5);
  var tmp_3 = await_0(this_1, $completion);
  if (tmp_3 === get_COROUTINE_SUSPENDED())
    tmp_3 = yield tmp_3;
  var otherItems = tmp_3;
  var tmp_4 = coroutineScope(repeatForScopeSets$slambda_0(otherItems, item, action), $completion);
  if (tmp_4 === get_COROUTINE_SUSPENDED())
    tmp_4 = yield tmp_4;
  return Unit_instance;
}
function repeatForScopeSets_0(item, action, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_repeatForScopeSets__9o68jz.bind(VOID, item, action), $completion);
}
function *_generator_repeatForScopeSets_BREAK_FOR_TESTING__tpybti(item, action, $completion) {
  if (item.e99() == null) {
    var tmp = action(item.hf9_1, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    return Unit_instance;
  }
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp_0 = await_0(this_0, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp_1 = tmp_0.mfv_1;
  // Inline function 'com.lightningkite.lightningdb.Query' call
  var limit = 2147483647;
  // Inline function 'kotlin.collections.listOf' call
  var orderBy = emptyList();
  // Inline function 'com.lightningkite.lightningdb.path' call
  // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
  var tmp_2 = serializerOrContextual(createKType(getKClass(LineItem()), arrayOf([]), false));
  var tmp$ret$2 = isInterface(tmp_2, KSerializer()) ? tmp_2 : THROW_CCE();
  var it = new (DataClassPathSelf())(tmp$ret$2);
  var tmp$ret$4 = and(and(eq(get_scopeSet(it), item.e99()), eq(get_state(it), item.kfy())), neq(get__id(it), item.kf9_1));
  var tmp$ret$5 = new (Query())(tmp$ret$4, orderBy, 0, limit);
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_1 = tmp_1.feo(tmp$ret$5);
  var tmp_3 = await_0(this_1, $completion);
  if (tmp_3 === get_COROUTINE_SUSPENDED())
    tmp_3 = yield tmp_3;
  var otherItems = tmp_3;
  var tmp_4 = coroutineScope(repeatForScopeSets_BREAK_FOR_TESTING$slambda_0(otherItems, item, action), $completion);
  if (tmp_4 === get_COROUTINE_SUSPENDED())
    tmp_4 = yield tmp_4;
  return Unit_instance;
}
function repeatForScopeSets_BREAK_FOR_TESTING(item, action, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_repeatForScopeSets_BREAK_FOR_TESTING__tpybti.bind(VOID, item, action), $completion);
}
function *_generator_invoke__zhh2q8($this, $this$async, $completion) {
  var tmp = $this.yg5_1($this.zg5_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_0($this, $this$coroutineScope, $completion) {
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = chunked(plus($this.ag6_1, $this.bg6_1), 5).m1();
  while (_iterator__ex2g4s.n1()) {
    var element = _iterator__ex2g4s.o1();
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList().u(collectionSizeOrDefault(element, 10));
    var _iterator__ex2g4s_0 = element.m1();
    while (_iterator__ex2g4s_0.n1()) {
      var item = _iterator__ex2g4s_0.o1();
      var tmp$ret$0 = async($this$coroutineScope, VOID, VOID, repeatForScopeSets$slambda$slambda_0($this.cg6_1, item));
      destination.v(tmp$ret$0);
    }
    var tmp = awaitAll(destination, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
  }
  return Unit_instance;
}
var repeatForScopeSets$slambda$slambdaClass;
function repeatForScopeSets$slambda$slambda() {
  if (repeatForScopeSets$slambda$slambdaClass === VOID) {
    class $ {
      constructor($action, $it) {
        this.yg5_1 = $action;
        this.zg5_1 = $it;
      }
      wah($this$async, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$async), $completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    repeatForScopeSets$slambda$slambdaClass = $;
  }
  return repeatForScopeSets$slambda$slambdaClass;
}
function repeatForScopeSets$slambda$slambda_0($action, $it) {
  var i = new (repeatForScopeSets$slambda$slambda())($action, $it);
  var l = ($this$async, $completion) => i.wah($this$async, $completion);
  l.$arity = 1;
  return l;
}
var repeatForScopeSets$slambdaClass;
function repeatForScopeSets$slambda() {
  if (repeatForScopeSets$slambdaClass === VOID) {
    class $ {
      constructor($otherItems, $item, $action) {
        this.ag6_1 = $otherItems;
        this.bg6_1 = $item;
        this.cg6_1 = $action;
      }
      wah($this$coroutineScope, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this, $this$coroutineScope), $completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    repeatForScopeSets$slambdaClass = $;
  }
  return repeatForScopeSets$slambdaClass;
}
function repeatForScopeSets$slambda_0($otherItems, $item, $action) {
  var i = new (repeatForScopeSets$slambda())($otherItems, $item, $action);
  var l = ($this$coroutineScope, $completion) => i.wah($this$coroutineScope, $completion);
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_1($this, $this$async, $completion) {
  var tmp = $this.dg6_1($this.eg6_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_2($this, $this$coroutineScope, $completion) {
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = chunked(dropLast(shuffled(plus($this.fg6_1, $this.gg6_1.hf9_1)), $this.fg6_1.p1() / 2 | 0), 15).m1();
  while (_iterator__ex2g4s.n1()) {
    var element = _iterator__ex2g4s.o1();
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList().u(collectionSizeOrDefault(element, 10));
    var _iterator__ex2g4s_0 = element.m1();
    while (_iterator__ex2g4s_0.n1()) {
      var item = _iterator__ex2g4s_0.o1();
      var tmp$ret$0 = async($this$coroutineScope, VOID, VOID, repeatForScopeSets_BREAK_FOR_TESTING$slambda$slambda_0($this.hg6_1, item));
      destination.v(tmp$ret$0);
    }
    var tmp = awaitAll(destination, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
  }
  return Unit_instance;
}
var repeatForScopeSets_BREAK_FOR_TESTING$slambda$slambdaClass;
function repeatForScopeSets_BREAK_FOR_TESTING$slambda$slambda() {
  if (repeatForScopeSets_BREAK_FOR_TESTING$slambda$slambdaClass === VOID) {
    class $ {
      constructor($action, $it) {
        this.dg6_1 = $action;
        this.eg6_1 = $it;
      }
      wah($this$async, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_1.bind(VOID, this, $this$async), $completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    repeatForScopeSets_BREAK_FOR_TESTING$slambda$slambdaClass = $;
  }
  return repeatForScopeSets_BREAK_FOR_TESTING$slambda$slambdaClass;
}
function repeatForScopeSets_BREAK_FOR_TESTING$slambda$slambda_0($action, $it) {
  var i = new (repeatForScopeSets_BREAK_FOR_TESTING$slambda$slambda())($action, $it);
  var l = ($this$async, $completion) => i.wah($this$async, $completion);
  l.$arity = 1;
  return l;
}
var repeatForScopeSets_BREAK_FOR_TESTING$slambdaClass;
function repeatForScopeSets_BREAK_FOR_TESTING$slambda() {
  if (repeatForScopeSets_BREAK_FOR_TESTING$slambdaClass === VOID) {
    class $ {
      constructor($otherItems, $item, $action) {
        this.fg6_1 = $otherItems;
        this.gg6_1 = $item;
        this.hg6_1 = $action;
      }
      wah($this$coroutineScope, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_2.bind(VOID, this, $this$coroutineScope), $completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    repeatForScopeSets_BREAK_FOR_TESTING$slambdaClass = $;
  }
  return repeatForScopeSets_BREAK_FOR_TESTING$slambdaClass;
}
function repeatForScopeSets_BREAK_FOR_TESTING$slambda_0($otherItems, $item, $action) {
  var i = new (repeatForScopeSets_BREAK_FOR_TESTING$slambda())($otherItems, $item, $action);
  var l = ($this$coroutineScope, $completion) => i.wah($this$coroutineScope, $completion);
  l.$arity = 1;
  return l;
}
//region block: exports
export {
  repeatForScopeSets_BREAK_FOR_TESTING as repeatForScopeSets_BREAK_FOR_TESTING1o9rhfik0wyta,
  repeatForScopeSets as repeatForScopeSets2sd4ktutrrxkj,
  repeatForScopeSets_0 as repeatForScopeSets14lknkq458s9b,
};
//endregion

//# sourceMappingURL=actions.mjs.map
